import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { Table, Spin, Space } from 'antd';
import { useAssociatedFunnelAnalyses } from '@src/services/queries';

export interface AssociatedFunnelAnalysesProps {
  type: 'critical_events' | 'dimensions';
  id: string;
}

const ASSET_NAME_MAP = {
  critical_events: 'Critical Event',
  dimensions: 'Dimension',
};

const AssociatedFunnelAnalyses = (props: AssociatedFunnelAnalysesProps) => {
  const { type, id } = props;
  const { data, isLoading } = useAssociatedFunnelAnalyses([type, id]);

  if (isLoading)
    return (
      <Space direction="vertical" align="center" style={{ display: 'flex', padding: 24 }}>
        <Spin tip="Loading..." />
      </Space>
    );

  if (!data?.length) return <p>No associated Funnel Analyses.</p>;

  return (
    <>
      <p>
        If this {ASSET_NAME_MAP[type]} is deleted, the following Funnel Analyses will be affected.
      </p>
      <Table
        loading={isLoading}
        rowKey="id"
        size="small"
        bordered
        showHeader={false}
        pagination={false}
        sortDirections={['ascend', 'descend', 'ascend']}
        columns={[
          {
            title: 'Associated Funnel Analyses',
            dataIndex: ['name'],
            render: (value, record) => (
              <NavLink to={`/funnels/saved/${record.id}`}>{value}</NavLink>
            ),
          },
        ]}
        dataSource={data}
      />
    </>
  );
};

export default React.memo(AssociatedFunnelAnalyses);
